import { Card } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { CheckCircle, AlertCircle, Clock, User } from "lucide-react";

const RecentActivity = () => {
  return (
    <Card className="p-6 hover:shadow-lg transition-all duration-300 bg-gradient-to-br from-white to-gray-50">
      <h2 className="text-xl font-semibold mb-4">Recent Activity</h2>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Action</TableHead>
              <TableHead className="hidden md:table-cell">User</TableHead>
              <TableHead className="hidden md:table-cell">Details</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="hidden md:table-cell">Time</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow className="hover:bg-gray-50/50">
              <TableCell>
                <div className="flex items-center space-x-2">
                  <User className="h-4 w-4 text-blue-500" />
                  <span>New Application</span>
                </div>
              </TableCell>
              <TableCell className="hidden md:table-cell">John Doe</TableCell>
              <TableCell className="hidden md:table-cell">Property Guarantee Application</TableCell>
              <TableCell>
                <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
                  <Clock className="h-3 w-3 mr-1" />
                  Pending
                </Badge>
              </TableCell>
              <TableCell className="hidden md:table-cell text-sm text-gray-500">2 minutes ago</TableCell>
            </TableRow>
            <TableRow className="hover:bg-gray-50/50">
              <TableCell>
                <div className="flex items-center space-x-2">
                  <CheckCircle className="h-4 w-4 text-green-500" />
                  <span>Verification</span>
                </div>
              </TableCell>
              <TableCell className="hidden md:table-cell">Jane Smith</TableCell>
              <TableCell className="hidden md:table-cell">ID Verification Approved</TableCell>
              <TableCell>
                <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                  <CheckCircle className="h-3 w-3 mr-1" />
                  Completed
                </Badge>
              </TableCell>
              <TableCell className="hidden md:table-cell text-sm text-gray-500">15 minutes ago</TableCell>
            </TableRow>
            <TableRow className="hover:bg-gray-50/50">
              <TableCell>
                <div className="flex items-center space-x-2">
                  <AlertCircle className="h-4 w-4 text-red-500" />
                  <span>Risk Alert</span>
                </div>
              </TableCell>
              <TableCell className="hidden md:table-cell">System</TableCell>
              <TableCell className="hidden md:table-cell">Unusual Activity Detected</TableCell>
              <TableCell>
                <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
                  <AlertCircle className="h-3 w-3 mr-1" />
                  Alert
                </Badge>
              </TableCell>
              <TableCell className="hidden md:table-cell text-sm text-gray-500">1 hour ago</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </Card>
  );
};

export default RecentActivity;